export default class EventObserver {
    constructor(target, method) {
        this.target = target;
        this.method = method;
    }

    call(params, dispatcher) {
        if (typeof this.method === 'string') {
            return this.target[this.method].apply(this.target || dispatcher, params);
        }

        return this.method.apply(this.target || dispatcher, params);
    }

    isEqual(target, method) {
        return this.target === target && this.method === method;
    }
}
